export default __webpack_public_path__ + "media/images/appel_entrant-e45025951288baf7f6ca85f387599a26.png";